import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export default function EmailPreview() {
  return (
    <div className="max-w-2xl mx-auto space-y-6 px-4 py-5">
      <Link to="/" className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-2xl flex items-center justify-center bg-blue-50 text-blue-700">
          <ShieldCheck size={24} />
        </div>

        <h1 className="font-heading text-2xl font-bold tracking-tight text-gray-900">
          RevUShield
        </h1>
      </Link>

      <Link
        to="/"
        className="inline-flex items-center gap-2 text-sm font-medium text-slate-500 hover:text-slate-900 transition"
      >
        ← Return to Homepage
      </Link>

      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 sm:p-8">
        <div className="border-b border-slate-200 pb-6 mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
            New review needs approval
          </h1>

          <p className="text-sm sm:text-base text-slate-500 mt-2 leading-relaxed">
            RevUShield prepared a response for{" "}
            <span className="font-medium text-slate-700">
              Joe&apos;s Coffee Shop
            </span>
            . Review it below before anything gets posted.
          </p>
        </div>

        <div className="space-y-5">
          <section className="rounded-2xl border border-slate-200 p-4 sm:p-5">
            <h2 className="text-lg font-semibold text-slate-900">
              Sarah Mitchell
            </h2>

            <p className="text-sm text-slate-500 mt-1">2 days ago</p>

            <div className="mt-3 text-yellow-400 tracking-wide text-xl">
              ★★★★★
            </div>

            <p className="text-sm sm:text-base text-slate-700 leading-7 mt-4">
              “Absolutely love this place! The staff was friendly, the service
              was fast, and everything exceeded my expectations.”
            </p>
          </section>

          <section className="rounded-2xl border border-indigo-100 bg-indigo-50 p-4 sm:p-5">
            <p className="text-sm font-semibold text-indigo-700">
              ✨ Suggested Response
            </p>

            <p className="text-sm sm:text-base text-slate-700 leading-7 mt-3">
              Thank you so much, Sarah! We’re thrilled to hear you had such a
              great experience with our team. We appreciate your support and
              hope to see you again soon!
            </p>

            <span className="inline-flex mt-4 rounded-full border border-indigo-100 bg-white px-3 py-1 text-xs font-semibold text-indigo-700">
              Tone: Professional & Friendly
            </span>
          </section>

          <div className="flex flex-col sm:flex-row gap-3">
            <button className="w-full sm:w-auto rounded-xl bg-indigo-600 px-5 py-3 text-sm font-semibold text-white hover:bg-indigo-700 transition">
              Approve & Post
            </button>

            <button className="w-full sm:w-auto rounded-xl border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition">
              Edit Response
            </button>

            <button className="w-full sm:w-auto rounded-xl border border-red-200 bg-white px-5 py-3 text-sm font-semibold text-red-700 hover:bg-red-50 transition">
              Reject
            </button>
          </div>

          <section className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
            <p className="text-sm text-slate-500 leading-relaxed">
              Responses are never posted automatically without approval. You can
              approve from this email or manage everything from your dashboard.
            </p>
          </section>
        </div>
      </div>

      <footer className="mt-10 border-t border-slate-200 pt-5 pb-2 text-sm text-slate-500 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <p>© 2026 RevUShield</p>

        <div className="flex flex-wrap items-center gap-4">
          <Link to="/legal/terms" className="hover:text-slate-900 transition">
            Terms
          </Link>

          <Link to="/legal/privacy" className="hover:text-slate-900 transition">
            Privacy
          </Link>

          <a
            href="mailto:support@revushield.com"
            className="hover:text-slate-900 transition"
          >
            Support
          </a>

          <span className="text-slate-400">v1.0</span>
        </div>
      </footer>
    </div>
  );
}
